export { default } from '../en/Tos';



// WEBPACK FOOTER //
// ./src/components/async/enTos.js